module.exports = __webpack_public_path__ + "img/20170319-9.9d2c1930.jpeg";